import Loading from '@/components/general/Loading';
import useApiFetch from '@/hooks/useApiFetch';
import checkinReports from '@/services/checkinReports';
import { FetchApiIds } from '@/types';
import { ResponseApiUsersCheckinsSummary } from '@/types/api';
import UsersPage from './Users.component';

const UsersContainer = function (): JSX.Element {
  const usersResponse = useApiFetch<ResponseApiUsersCheckinsSummary>(
    FetchApiIds.USERS_CHECKINS_SUMMARY,
    checkinReports.getUsersCheckinsSummary
  );

  if (usersResponse.isLoading) return <Loading fullPage />;

  return <UsersPage users={usersResponse.data?.summary ?? []} />;
};

export default UsersContainer;
